import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthdataService } from './authdata.service';

@Injectable({
  providedIn: 'root'
})
export class CheckauthGuard implements CanActivate {
  
  constructor(private _AuthdataService:AuthdataService, private _router:Router){

    
  }
  canActivate(  route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    if(localStorage.getItem("Token")){
      return true

    }else {
this._router.navigate(['/login'])
      return false
    }


  }
  
}
